import type { AxiosInstance } from 'axios';

const CORRELATION_HEADER = 'X-Correlation-Id';

function generateCorrelationId(): string {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }

  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

export const CorrelationInterceptor = {
  addCorrelationInterceptor(axiosInstance: AxiosInstance): void {
    axiosInstance.interceptors.request.use((config) => {
      if (!config.headers[CORRELATION_HEADER]) {
        config.headers[CORRELATION_HEADER] = generateCorrelationId();
      }
      return config;
    });
  },
};

export default CorrelationInterceptor;
